import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import analyticsService from '../services/analytics';

/**
 * Hook to track page views automatically
 */
export const usePageTracking = (pageName) => {
  const location = useLocation();

  useEffect(() => {
    // Start tracking this page
    analyticsService.startPageTracking();
    
    // Track page view
    analyticsService.trackPageView(pageName || location.pathname);
  }, [location, pageName]);
};

/**
 * Hook to access analytics service
 */
export const useAnalytics = () => {
  return {
    trackPageView: (pageName, data) => analyticsService.trackPageView(pageName, data),
    trackProductView: (productId, productName, categoryId, categoryName, price) => 
      analyticsService.trackProductView(productId, productName, categoryId, categoryName, price),
    trackSearch: (query, resultsCount) => analyticsService.trackSearch(query, resultsCount),
    trackAddToCart: (productId, productName, quantity, price) => 
      analyticsService.trackAddToCart(productId, productName, quantity, price),
    trackRemoveFromCart: (productId, productName) => 
      analyticsService.trackRemoveFromCart(productId, productName),
    trackCheckoutStarted: (cartTotal, itemCount) => 
      analyticsService.trackCheckoutStarted(cartTotal, itemCount),
    trackPurchase: (orderId, orderTotal, itemCount) => 
      analyticsService.trackPurchase(orderId, orderTotal, itemCount),
    trackCategoryView: (categoryId, categoryName) => 
      analyticsService.trackCategoryView(categoryId, categoryName),
    trackWishlistAdd: (productId, productName) => 
      analyticsService.trackWishlistAdd(productId, productName),
    trackFilterUsage: (filterType, filterValue) => 
      analyticsService.trackFilterUsage(filterType, filterValue),
    trackEvent: (eventType, eventData) => analyticsService.trackEvent(eventType, eventData),
  };
};

export default useAnalytics;
